import React, { useState, useEffect } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import swal from "sweetalert";
import MainPagetitle from '../../layouts/MainPagetitle';
import CalenderSevice from '../../api/services/CalenderSevice';
import LogoAnimationLoader from '../Loading/LogoAnimationLoader';
const BookingCalenderList = () => {
    const [Error, setError] = useState('');
    const [isLoading, setisloading] = useState(true);
    const [CalenderList, setCalenderList] = useState([]);
    const [currentPage, setCurrentPage] = useState(1);
    const recordsPage = 50;
    const lastIndex = currentPage * recordsPage;
    const firstIndex = lastIndex - recordsPage;
    const records = CalenderList.slice(firstIndex, lastIndex);
    const npage = Math.ceil(CalenderList.length / recordsPage)
    const number = [...Array(npage + 1).keys()].slice(1)
    const navigate = useNavigate();
    function prePage() {
        if (currentPage !== 1) {
            setCurrentPage(currentPage - 1)
        }
    }
    function changeCPage(id) {
        setCurrentPage(id);
    }
    function nextPage() {
        if (currentPage !== npage) {
            setCurrentPage(currentPage + 1)
        }
    }


    const getCalenderList = async () => {

        try {
            let responseData = await CalenderSevice.index().json()
            setCalenderList(responseData.data)
            setisloading(false);
        } catch (error) {
            if (error.name === 'HTTPError') {
                const errorJson = await error.response.json();

                setError(errorJson.message)
            }
        }
    }
    useEffect(() => {
        if (localStorage.getItem('admintoken')) {

            getCalenderList();

        }
        else {
            navigate('/');
        }

    }, [])
    const handleDelete = async (e) => {

        try {


            let responseData = await CalenderSevice.destroy(e).json()
            if (responseData.status === true) {
                swal("Booking Delete Succesfully").then((willDelete) => {
                    if (willDelete) {
                        getCalenderList();
                    }
                })

            }

        } catch (error) {
            if (error.name === 'HTTPError') {
                const errorJson = await error.response.json();
                setError(errorJson.message)
            }
        }
    }

    return (
        <>
        <MainPagetitle mainTitle="Celender Managment" pageTitle={'Celender Managment'} parentTitle={'Home'} />
            <div className="container-fluid">
                <div className="row">
                    <div className="col-xl-12">
                        <div className="card">
                            <div className="card-body p-0">
                                <div className="table-responsive active-projects style-1 ItemsCheckboxSec shorting">
                                    <div className="tbl-caption d-flex justify-content-between text-wrap align-items-center">
                                        <h4 className="heading mb-0">Celender Managment List</h4>

                                    </div>
                                    <div id="employee-tbl_wrapper" className="dataTables_wrapper no-footer">
                                        <table id="empoloyees-tblwrapper" className="table ItemsCheckboxSec dataTable no-footer mb-0">
                                            <thead>
                                                <tr style={{ textAlign: 'center' }}>
                                                    <th >
                                                        <strong>No.</strong>
                                                    </th>
                                                    <th>
                                                        <strong>Camper</strong>
                                                    </th>
                                                    <th>
                                                        <strong>Start Date</strong>
                                                    </th>
                                                    <th>
                                                        <strong>End Date</strong>
                                                    </th>
                                                    <th><strong>Action</strong></th>
                                                </tr>
                                            </thead>
                                            <tbody>

                                                {
                                                    records.map((element, index) => {

                                                        return (
                                                            <tr style={{ textAlign: 'center' }}>
                                                                <td>
                                                                    {index + 1}
                                                                </td>
                                                                <td>
                                                                    {element.camper_name}

                                                                </td>

                                                                <td>{element.startdate}</td>
                                                                <td>{element.enddate}</td>
                                                                <td>
                                                                    <div className="d-flex">

                                                                        <Link
                                                                            onClick={() =>
                                                                                swal({
                                                                                    title: "Are you sure?",

                                                                                    icon: "warning",
                                                                                    buttons: true,
                                                                                    dangerMode: true,
                                                                                }).then((willDelete) => {
                                                                                    if (willDelete) {
                                                                                        (handleDelete(element.id));
                                                                                    }
                                                                                })
                                                                            }

                                                                            className="btn btn-danger shadow btn-xs sharp"
                                                                        >
                                                                            <i className="fa fa-trash"></i>
                                                                        </Link>
                                                                    </div>
                                                                </td>
                                                            </tr>
                                                        )
                                                    })
                                                }

                                            </tbody>

                                        </table>
                                        <div className="d-sm-flex text-center justify-content-between align-items-center">
                                            <div className='dataTables_info'>
                                                Showing {lastIndex - recordsPage + 1} to{" "}
                                                {CalenderList.length < lastIndex ? CalenderList.length : lastIndex}
                                                {" "}of {CalenderList.length} entries
                                            </div>
                                            <div
                                                className="dataTables_paginate paging_simple_numbers justify-content-center"
                                                id="example2_paginate"
                                            >
                                                <Link
                                                    className="paginate_button previous disabled"
                                                    to="#"
                                                    onClick={prePage}
                                                >
                                                    <i className="fa-solid fa-angle-left" />
                                                </Link>
                                                <span>
                                                    {number.map((n, i) => (
                                                        <Link className={`paginate_button ${currentPage === n ? 'current' : ''} `} key={i}
                                                            onClick={() => changeCPage(n)}
                                                        >
                                                            {n}

                                                        </Link>
                                                    ))}
                                                </span>
                                                <Link
                                                    className="paginate_button next"
                                                    to="#"
                                                    onClick={nextPage}
                                                >
                                                    <i className="fa-solid fa-angle-right" />
                                                </Link>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            {isLoading && <LogoAnimationLoader />}

        </>
    );
};

export default BookingCalenderList;
